<template>
  <div class="civilization">
    <div class="imgcon">
      <img src="@/assets/images/report/civilization.png" alt="" />
    </div>
    <div class="point">
      <div class="title"><span></span>督查点位</div>
      <div class="point-list">
        <div
          :class="index == item.id ? 'active' : ''"
          v-for="(item, i) in pointList"
          :key="i"
          @click="setIndex(item)"
        >
          {{ item.title }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { getCateList } from "./api";
export default {
  data() {
    return {
      index: -1,
      pointList: [],
    };
  },
  computed: {
    ...mapGetters({
      cateGet: "cate/get",
    }),
    point() {
      return this.cateGet("point").id;
    },
  },
  watch: {
    point: {
      immediate: true,
      handler(v) {
        this.index = v;
      }
    },
  },
  created() {
    this.getCateList();
  },
  methods: {
    ...mapActions({
      setPoint: "cate/setPoint",
      setDepartList: "cate/setDepartList",
    }),
    getCateList() {
      let params = {
        version: 2,
      };
      getCateList(params).then((res) => {
        // console.log('点位列表', res)
        this.pointList = res.data;
      });
    },
    setIndex(item) {
      const { id, title, department,require } = item || {};
      this.index = id;
      this.setPoint(item);
      this.setDepartList(department);
      this.$router.push({
        name: "eventList",
        query: {
          // id: id,
          require: require,
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
.civilization {
  padding: 17px 15px;
  .imgcon {
    width: 6.9rem;
    height: 3.08rem;
    margin-bottom: 23px;
    img {
      height: 100%;
      width: 100%;
    }
  }
  .point {
    .title {
      height: 22px;
      line-height: 22px;
      font-size: 16px;
      text-align: left;
      margin-bottom: 10px;
      span {
        display: inline-block;
        vertical-align: middle;
        height: 6px;
        width: 6px;
        border-radius: 50%;
        background: #206aff;
        margin-right: 10px;
      }
    }
    .point-list {
      // display: flex;
      // justify-content: space-between;
      // flex-wrap: wrap;
      div {
        height: 34px;
        padding: 0 15px;
        line-height: 34px;
        font-size: 12px;
        color: #999999;
        background: rgba(238, 242, 241, 1);
        text-align: center;
        margin-bottom: 10px;
        border-radius: 2px;
        display: inline-block;
        margin-left: 10px;
        margin-right: 5px;
      }
      .active {
        color: #ffffff;
        background: #206aff;
      }
    }
  }
}
</style>
